module.exports = __webpack_public_path__ + "img/myposition_wm_박지성.456644fc.png";